import $ from 'jquery';
import './partials/sidebar.js';
import './partials/chat.js';
import './partials/accordion.js';
import './partials/inputValue.js';
import './partials/radioCheck.js';
import './partials/addJurymember.js';
import './partials/upload.js';
import './partials/videopitch.js';
import './partials/subscribe.js';
import './partials/nominateForm.js';

if($('.image--full-width').css('background-image') == 'none'){
	$('.image--full-width').css('padding-top', '30%')
}

if($('.news__article-header').css('background-image') == 'none'){
	$('.news__article-header').css('padding-top', '30%')
}

$('.news__item').click(function() {
	window.location.href = $(this).find('a').attr('href');
});



// WEBPACK FOOTER //
// ./app/src/assets/js/script.js